import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { appSettings } from '../app-settings';

export interface SupportSlot {
	TimeString: string;
	IsBookable: boolean;
}

export interface SupportClientBasic {
	ClientId: number;
	ClientCode: string;
	FirstName: string;
	LastName: string;
	Email: string;
	PhoneNumberOwner: string;
	PhoneNumberBusiness: string;
	BusinessName: string;
	LastDeviceType: string;
	IsActive: boolean;
	Sponsor: string;
}

export interface SupportModel {
	Id: number;
	ClientId: number;
	Operator: string;
	SupportDate: string | null;
	AppCode: string;
	State: string;
	StateSupport: string;
	Note: string | null;
	Created: string;
	CreatedBy: string;
	Modified: string;
	ModifiedBy: string;
	Effort: number;
	AppointmentDuration: number;
	AppointmentLocation: string | null;
	CollaboratorId: number | null;
	IsAppointment: boolean;
	AppointmentStatus: number | null;
	IsDeleted: boolean;
}

export interface SupportAppointment {
	Support: SupportModel;
	Client: SupportClientBasic;
}

@Injectable({
	providedIn: 'root',
})
export class SupportBookingService {
	constructor(private http: HttpClient) {}

	getPublicAvailableSlots(
		date: Date,
		durationMinutes: number,
		collaboratorIds: number[],
	) {
		let params = new HttpParams()
			.set('date', date.toISOString())
			.set('durationMinutes', durationMinutes);

		for (const id of collaboratorIds || []) {
			params = params.append('collaboratorIds', id);
		}

		return this.http.get<SupportSlot[]>(`${appSettings.API.SUPPORT}/public-slots`, { params });
	}

	getPublicClientAppointments(clientId: number) {
		const params = new HttpParams().set('clientId', clientId);

		return this.http.get<SupportAppointment[]>(`${appSettings.API.SUPPORT}/public-appointments`, { params });
	}

	createPublicAppointment(
		clientId: number,
		date: Date,
		timeString: string,
		durationMinutes: number,
		collaboratorIds: number[],
		licenseId: string | null = null,
		note: string | null = null,
		state: string | null = null,
	) {
		return this.http.post<SupportModel>(`${appSettings.API.SUPPORT}/public-appointment`, {
			ClientId: clientId,
			Date: date.toISOString(),
			TimeString: timeString,
			DurationMinutes: durationMinutes,
			CollaboratorIds: collaboratorIds || [],
			LicenseId: licenseId || null,
			Note: note || null,
			State: state || null,
		});
	}

	deletePublicAppointment(id: number, clientId: number) {
		const params = new HttpParams().set('clientId', clientId);

		return this.http.delete<void>(`${appSettings.API.SUPPORT}/public-appointment/${id}`, { params });
	}
}
